import React, { FC } from 'react';
import cn from 'classnames';
import { FormattedMessage } from 'react-intl';
import NextImage from 'src/shared-components/NextImage/NextImage';
import useGTAG, { GTAGPrefix } from 'src/hooks/useGTAG';
import trns from './trns';

const figures = 'shared/figures.svg';

interface Props {
  handleOpenCatalog: () => void;
  gtagPrefix?: GTAGPrefix;
}

// eslint-disable-next-line react/display-name
const CatalogButton: FC<Props> = ({ handleOpenCatalog, gtagPrefix }) => {
  const { trackGtagEvent } = useGTAG();
  return (
    <div className="h-9.5 hover:bg-bahamaBlue lm:ml-9">
      <button
        onClick={() => {
          handleOpenCatalog();
          trackGtagEvent(`${gtagPrefix}_catalog`);
        }}
        className={cn(
          'grow text-center justify-center items-center cursor-pointer px-3  h-full hidden sm:flex '
        )}
        data-cy="catalog-header-link"
      >
        <div className="relative pt-[1px]">
          <NextImage
            alt="Справочник лекарств LIKIE"
            title="Справочник лекарств"
            src={figures}
            layout="fixed"
            itemProp="logo"
            quality={100}
            width={13}
            height={13}
            priority
          />
        </div>
        <p className="text-white fs-body-bold uppercase whitespace-nowrap ml-[14px]">
          <FormattedMessage {...trns.catalogLabel} />
        </p>
      </button>
    </div>
  );
};

CatalogButton.displayName = 'CatalogButton';

export default CatalogButton;
